var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auth-wrapper auth-v2"
  }, [_c('b-row', {
    staticClass: "auth-inner m-0"
  }, [_c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center flex-column text-center p-5",
    attrs: {
      "lg": "12"
    }
  }, [_vm.loading ? _c('b-spinner', {
    attrs: {
      "label": "Loading..."
    }
  }) : _c('div', [_vm.error ? _c('h2', {
    staticClass: "text-danger mb-2"
  }, [_vm._v(_vm._s(_vm.error))]) : _c('h2', {
    staticClass: "text-success mb-2"
  }, [_vm._v("Finalizing your account...")]), !_vm.error ? _c('p', [_vm._v("Please wait while we log you in automatically.")]) : _vm._e()])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }